"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkIntegrityChecker = void 0;
const store_1 = require("../exports/store");
const types_1 = require("../types");
// resolve one-way association
class LinkIntegrityChecker {
    constructor(store) {
        this.store = store;
    }
    parse(actions, datasheetId, linkedActions) {
        if (linkedActions === null || linkedActions === void 0 ? void 0 : linkedActions.length) {
            return actions;
        }
        const state = this.store.getState();
        for (const action of actions) {
            if (!action.p.includes('fieldMap')) {
                continue;
            }
            const data = (action['oi'] || action['od']);
            const currentField = store_1.Selectors.getField(state, data.id, datasheetId);
            if (currentField.type !== types_1.FieldType.Link) {
                continue;
            }
            return [];
        }
        return actions;
    }
}
exports.LinkIntegrityChecker = LinkIntegrityChecker;
//# sourceMappingURL=link_integrity_checker.js.map